"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Globe, MapPin, ChartLine, Compass, Briefcase, Handshake } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "SEO & Local SEO",
  description: "Dominate local search results and drive organic traffic with our data-driven optimization strategies built for small business visibility.",
  icon: Globe
}, {
  title: "Digital Marketing Strategy",
  description: "Custom roadmaps designed to align your digital presence with revenue goals, ensuring every marketing dollar works toward growth.",
  icon: Compass
}, {
  title: "Paid Search Advertising",
  description: "High-conversion Google Ads campaigns that place your brand in front of ready-to-buy customers at the exact moment they search.",
  icon: ChartLine
}, {
  title: "Social Media Marketing",
  description: "Engage your local community and build brand loyalty through strategic social content and targeted advertising across platforms.",
  icon: Handshake
}, {
  title: "Branding & Positioning",
  description: "Define your unique value proposition with professional branding that establishes authority and trust in your local market.",
  icon: Briefcase
}, {
  title: "Revenue Growth Consulting",
  description: "Beyond lead gen, we analyze your entire sales funnel to identify bottlenecks and implement solutions that maximize total revenue.",
  icon: MapPin
}];
export default function TheGrowthBlueprint() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="95530" id="our-specialized-marketing-solutions" className="py-24 md:py-32 bg-[#F6FAFE] text-[#464646] overflow-hidden">
      <div ref={ref} className={`container mx-auto px-6 md:px-8 max-w-7xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="max-w-3xl mb-16 md:mb-24">
          <h2 className="font-sans text-4xl md:text-5xl tracking-tight text-[#000000] font-bold mb-6">
            Our Specialized Marketing Solutions
          </h2>
          <p className="font-sans text-base md:text-lg text-[#464646] leading-relaxed">Architectural precision meets high-energy growth. In partnership with <Link to="https://aerobomerang.com" newTab>Aerobomerang</Link>, we provide comprehensive digital marketing services tailored to help small and local businesses dominate their regional markets.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, i) => <Card key={i} data-index={i} className="border-none border-b-4 border-transparent bg-white shadow-md transition-all duration-200 hover:-translate-y-1 hover:shadow-xl hover:border-[#FF6600] group">
              <CardHeader className="p-8 md:p-10">
                <service.icon className="w-12 h-12 stroke-[1.5] text-[#FF6600] mb-6 transition-transform duration-200 group-hover:scale-105" />
                <CardTitle className="font-sans text-xl md:text-2xl font-medium tracking-tight text-[#000000] mb-4">
                  {service.title}
                </CardTitle>
                <CardDescription className="font-sans text-sm md:text-base text-[#464646] leading-relaxed">
                  {service.description}
                </CardDescription>
              </CardHeader>
            </Card>)}
        </div>

        <div className="mt-20 flex justify-center md:justify-start">
          <Button size="lg" variant="default" className="font-sans text-sm font-bold tracking-widest uppercase bg-[#FF6600] hover:bg-[#E65C00] text-white px-8 py-6 transition-colors duration-200" asChild>
            <Link to="/ServicesAndSEOPage">Explore Our Services</Link>
          </Button>
        </div>
      </div>
    </section>;
}